export default __webpack_public_path__ + "static/media/step1.99dfce75.webp";